import React from "react";

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }
  static getDerivedStateFromError() {
    return { hasError: true };
  }
  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error("Render error:", error, info);
  }
  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex flex-col items-center justify-center bg-ab-black text-center px-6">
          <div className="font-serif text-3xl text-ab-ivory mb-3">ANYANG <span className="text-ab-gold">BETI</span></div>
          <p className="text-ab-ivory/70 mb-6">Une erreur est survenue lors de l'affichage de cette page.</p>
          <button onClick={() => (window.location.href = "/")} className="ab-btn-primary">Retour à l'accueil</button>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
